module.exports = __webpack_public_path__ + "static/wyvern-04cbdc46add6996916e588ed78c9cd9a.jpg";